import { useCallback, useMemo } from 'react';

import moment from 'moment'

import { HeaderSeparator, ReportHeader, ReportHeaderDates, ReportHeaderDesktopActions, ReportHeaderMobileActions } from '@/components/reports/header';
import appStore from 'stores/app'

import HierarchicalHeader from '../hierarchical-report/Header';

export default function Header({ value, isLoading, onApply, title, mobileActions, children }) {
  const dates = useMemo(() => {
    const { startDate, endDate } = value
    return {
      startDate: startDate ? moment.utc(startDate).tz(appStore.timezone) : null,
      endDate: endDate ? moment.utc(endDate).tz(appStore.timezone) : null,
    }
  }, [value])

  const handleChange = useCallback(({ startDate, endDate }) => {
    if (startDate && endDate) {
      onApply({ startDate, endDate })
    }
  }, [onApply])

  return <ReportHeader title={`${title} Report`}>
    <ReportHeaderDates>
      <HierarchicalHeader dates={dates} isLoading={isLoading} onChange={handleChange} />
    </ReportHeaderDates>
    <HeaderSeparator />
    <ReportHeaderDesktopActions>
      {children}
    </ReportHeaderDesktopActions>
    <ReportHeaderMobileActions>
      {mobileActions}
    </ReportHeaderMobileActions>
  </ReportHeader>
}
